import { Alert, Button, Card, Flex, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { http } from '@/api/http';
import { pointHttpAt } from '@/desktop';
import { problemMessage } from '@/i18n/problem';
import { normalizeServerUrl, saveServerUrl, serverUrl } from '@/runtime';

/** Десктопный клиент: адрес сервера склада — при первом запуске и по «Сменить сервер». */
export function ServerPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit({ url }: { url: string }) {
    setError(null);
    const base = normalizeServerUrl(url);
    if (!base) {
      setError(t('server.badUrl'));
      return;
    }
    setBusy(true);
    const previous = serverUrl();
    pointHttpAt(base);
    try {
      await http.get('/api/v1/health');
      saveServerUrl(base);
      void navigate('/login', { replace: true });
    } catch (e) {
      pointHttpAt(previous);
      setError(t('server.unreachable', { url: base, reason: problemMessage(e) }));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Card style={{ width: 440 }}>
        <Typography.Title level={4}>{t('server.title')}</Typography.Title>
        <Typography.Paragraph type="secondary">{t('server.hint')}</Typography.Paragraph>
        <Form
          layout="vertical"
          initialValues={{ url: serverUrl() ?? '' }}
          onFinish={(v: { url: string }) => void submit(v)}
        >
          <Form.Item
            name="url"
            label={t('server.url')}
            rules={[{ required: true, whitespace: true, message: t('server.required') }]}
          >
            <Input placeholder="https://sklad.example.ru" autoFocus />
          </Form.Item>
          {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} />}
          <Button type="primary" htmlType="submit" block loading={busy}>
            {t('server.save')}
          </Button>
        </Form>
      </Card>
    </Flex>
  );
}
